import React, { useEffect, useState } from 'react';
import { WizardTitle } from '../../components/WizardTitle';
import IWizardStep from '../../../../interfaces/IWizardStep';
import { BsClockHistory, BsFillClipboard2HeartFill } from 'react-icons/bs';
import { Box, Container, List, Module } from './AttestationOrPoint.styles';
import { useLocalStorage } from '../../../../hooks/providers/useLocalStorage';
import { useCalculationDate } from '../../../../hooks/services/useCalculationDate';
import { useToastrVanila } from '../../../../hooks/util/useToastrVanila';
import { CiViewList } from 'react-icons/ci';
import { useNavigate } from 'react-router-dom';

interface AttestationOrPointProps extends IWizardStep {}

const AttestationOrPoint = (props: AttestationOrPointProps) => {
  const [loading, setLoading] = useState(false);
  const [iconColor, setIconColor] = useState('black');
  const localStorage = useLocalStorage();
  const navigate = useNavigate();
  const request = useCalculationDate();
  const toastr = useToastrVanila();

  const storage = localStorage.getItem('medicalCertificate');
  const usePoint = localStorage.getItem('useTimeClocking');
  const employeeId = storage.employeeId;

  const listPointControlCalculationDate = async () => {
    setLoading(true);
    await request
      .listCalculationDate(employeeId)
      .then(result => {
        props.medicalCertificate.calculationDate = `${result[0]?.initialDate} ${result[0]?.finalDate}`;
        props.medicalCertificate.allowsChange = result[0]?.allowsChange;
      })
      .catch(error => {
        toastr.error(error.message);
      });
  };

  useEffect(() => {
    setIconColor(localStorage.getItem('isDark') === true ? 'white' : 'black');
  }, []);

  const handleSubmitAttestation = async () => {
    await props.setStep(props.step + 1, {
      ...props.medicalCertificate,
      startTime: String(new Date()),
      endTime: String(new Date()),
    });
    setLoading(false);
  };

  const handleSubmitPoint = async () => {
    await listPointControlCalculationDate();

    await props.setStep(props.step + 3, {
      ...props.medicalCertificate,
      startTime: String(new Date()),
      endTime: String(new Date()),
    });

    setLoading(false);
  };

  return (
    <Container>
      <WizardTitle>Selecione o módulo desejado:</WizardTitle>

      <Box>
        {usePoint ? (
          <List>
            {
              <Module>
                <button name="ponto" disabled={loading} onClick={handleSubmitPoint}>
                  <BsClockHistory size={80} color={iconColor} />
                </button>
                <label htmlFor="ponto">Controle de Ponto</label>
              </Module>
            }
            <Module>
              <button name="atestado" disabled={loading} onClick={handleSubmitAttestation}>
                <BsFillClipboard2HeartFill size={80} color={iconColor} />
              </button>
              <label htmlFor="atestado">Enviar Atestado</label>
            </Module>
            <Module>
              <button name="atestado" disabled={loading} onClick={() => navigate('/atestados-status')}>
                <CiViewList size={80} color={iconColor} />
              </button>
              <label htmlFor="atestado">Visualizar Atestados</label>
            </Module>
            <Module>
              <button name="atestado" disabled={loading} onClick={handleSubmitAttestation}>
                <BsFillClipboard2HeartFill size={80} color={iconColor} />
              </button>
              <label htmlFor="atestado">Visualizar Documentos Enviados</label>
            </Module>
          </List>
        ) : (
          <List>
            <Module>
              <button name="atestado" disabled={loading} onClick={handleSubmitAttestation}>
                <BsFillClipboard2HeartFill size={80} color={iconColor} />
              </button>
              <label htmlFor="atestado">Atestado</label>
            </Module>
            <Module>
              <button name="atestado" disabled={loading} onClick={() => navigate('/atestados-status')}>
                <CiViewList size={80} color={iconColor} />
              </button>
              <label htmlFor="documentos" style={{ fontSize: 14 }}>
                Documentos Enviados
              </label>
            </Module>
          </List>
        )}
      </Box>
    </Container>
  );
};

export default AttestationOrPoint;
